import { instance } from '../config';

export default function searchDataset({ q }) {
  return instance.get(`/search?q=${encodeURIComponent(q)}`);
}
